import { render, staticRenderFns } from "./LinhaDeRecebimentosResumo.vue?vue&type=template&id=6864a7fa&scoped=true"
import script from "./LinhaDeRecebimentosResumo.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeRecebimentosResumo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeRecebimentosResumo.vue?vue&type=style&index=0&id=6864a7fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6864a7fa",
  null
  
)

export default component.exports